<script>
  import { scaleLinear } from "d3-scale";
  import Grid from "./Grid.svelte";
  export let colorScale;
  export let reversePalette;
  export let legendLabel;
  export let selectedPalette;

  const marginTop = 20;
  const width = 320;
  const height = 40;

  $: legendScale = reversePalette
    ? scaleLinear().domain(colorScale.domain()).range([width, 0])
    : scaleLinear().domain(colorScale.domain()).range([0, width]);
  $: legendTicks = legendScale.ticks();

  const stripN = 400

  function generateStrips(palette){
    let strips = [];
    for (let i = 0; i < stripN; ++i) {
    strips.push(selectedPalette(i / (stripN - 1)));
  }
  return strips
  }
  $: strips = generateStrips(selectedPalette)
  $: legendStrips = reversePalette ? strips.slice().reverse() : strips

  const stripWidth = width/stripN
</script>
<text x={0} y={16} text-anchor="start">{legendLabel}</text>
<g class="legend-gradient">
  {#each legendStrips as strip, i}
    <rect
      x={i*stripWidth}
      y={marginTop}
      width={stripWidth}
      height={height - marginTop}
      fill={strip}
    />
  {/each}
  </g>
  <g transform="translate(0,20)">
    <Grid
      gridType="xGrid"
      innerHeight={height - marginTop}
      innerWidth={width}
      scale={legendScale}
      ticks={legendTicks}
      numberFormat=","
    />
  </g>
